import Vue from "vue";
import { Component } from "vue-property-decorator";
import { EventBus } from "../../Controls/EventBus";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametresInstance } from "../../Controls/Parameters";
import { SocieteDsnDto } from "../../../dto/GenApi.iNotPaie.Dto/SocieteDsnDto";
import { OrganismeDto } from "../../../dto/GenApi.iNotPaie.Dto/OrganismeDto";
import { RubriqueDto } from "../../../dto/GenApi.iNotPaie.Dto/RubriqueDto";
import ModalAjoutUpdateOrganisme from "./modalAjoutUpdateOrganisme/modalAjoutUpdateOrganisme";
import { ModalAlerteOptions } from "../../modalComponents/modalAlerte/modalAlerte";
import $ from "jquery";
import EventConstants from "../../Controls/EventConstants";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component({
	components: {
		ModalAjoutUpdateOrganisme: require("./modalAjoutUpdateOrganisme/modalAjoutUpdateOrganisme.vue.html")
	}
})
export default class DsnSocieteComponent extends Vue {
	public SocieteDsn: SocieteDsnDto = { Id: 0, Organismes: [] };
	public organismesAffiches: OrganismeDto[] = [];
	public rubriques: RubriqueDto[] = [];
	public dataReady = false;
	public modalAjoutUpdateOrganisme?: ModalAjoutUpdateOrganisme = undefined;
	public currentOrderColumn = "Type";
	public orderingDesc = true;

    public Init(): void {
    	this.dataReady = false;
    	if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined) {
			ServicesFactoryInstance.SocieteService.getSocieteDsn(ParametresInstance.societeCourante.Code, (data) => {
    			this.SocieteDsn = data;
    			this.organismesAffiches = this.SocieteDsn.Organismes.filter(o => (o.Type != "O" && o.Type != undefined) || (o.Type != undefined && o.Type == "O" && (o.Regime == "CRPCEN" || o.Regime == "DGFIP" || o.Regime == "URSSAF")));
    			this.rubriques = ParametresInstance.listeRubriques;
                this.getClassOfOrder(this.currentOrderColumn, true);
    			this.dataReady = true;
    			this.$forceUpdate();
    		});
		}
	}

	public getClassOfOrder(columnName: string, desc: any): string {
    	if (columnName == this.currentOrderColumn && this.orderingDesc == desc) {
    		return "active";
    	}

    	return "icons";
	}

	public orderBy(columnName: string): void {
    	if (this.currentOrderColumn == columnName) {
    		this.orderingDesc = !this.orderingDesc;
    	} else {
    		this.orderingDesc = true;
    	}
    	this.currentOrderColumn = columnName;
    	this.doOrder();
	}

	public doOrder(): void {
    	const orderingDesc = this.orderingDesc;
    	const columnName = this.currentOrderColumn;
    	if (this.organismesAffiches != undefined) {
    		this.organismesAffiches.sort(function(a, b) {
    			if (a[columnName] < b[columnName]) {
					return (orderingDesc ? -1 : 1);
				}
    			if (a[columnName] > b[columnName]) {
					return (orderingDesc ? 1 : -1);
				}

    			return 0;
    		});
    	}
	}

	public annuler(): void {
    	this.Init();
	}

	public ajout(): void {
    	if (this.modalAjoutUpdateOrganisme == undefined) {
			this.modalAjoutUpdateOrganisme = this.$refs.modalAjoutUpdateOrganisme as ModalAjoutUpdateOrganisme;
		}

    	this.modalAjoutUpdateOrganisme.Init(this.SocieteDsn);
    	$("#modalAjoutUpdateOrganisme").modal("show");
	}

	public deleteItem(organisme: OrganismeDto): void {
    	const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
            message: "Souhaitez-vous vraiment supprimer cet organisme ?",
    		callBackYes: () => {
    			this.deleteItemYes(organisme);
    		}
    	});
    	EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
	}

	public deleteItemYes(organisme: OrganismeDto): void {
    	for (const o of this.SocieteDsn.Organismes) {
    		if (o.Id == organisme.Id) {
    			this.SocieteDsn.Organismes.splice(this.SocieteDsn.Organismes.indexOf(o), 1);
    			ServicesFactoryInstance.SocieteService.updateSocieteDsn(this.SocieteDsn, () => {
    				this.annuler();
    				NotificationServiceInstance.SendSuccess("La société a été modifiée avec succès.");
    				this.$emit("refresh");
    			});
    		}
    	}
	}

	public update(organisme: OrganismeDto): void {
    	if (this.modalAjoutUpdateOrganisme == undefined) {
			this.modalAjoutUpdateOrganisme = this.$refs.modalAjoutUpdateOrganisme as ModalAjoutUpdateOrganisme;
		}

    	this.modalAjoutUpdateOrganisme.Init(this.SocieteDsn, organisme);
    	$("#modalAjoutUpdateOrganisme").modal("show");
	}

	public getTableauHeight(): string {
    	return "height: " + (70 + this.organismesAffiches.length * 50) + "px;";
	}

	public getLibelleType(type: string, regime: string): string {
    	switch (type) {
    		case "M":
    			return "Mutuelle";
    		case "P":
    			return "Prévoyance";
    		case "R":
    			return "Retraite";
    		case "C":
    			return "Siret CRPCEN";
    		case "U":
    			return "Siret URSSAF";
    		case "D":
    			return "Siret DGFIP";
    		case "O":
    			switch (regime) {
    				case "CRPCEN":
    					return "Siret CRPCEN";
    				case "URSSAF":
    					return "Siret URSSAF";
    				case "DGFIP":
    					return "Siret DGFIP";
    			}
    	}

    	return "";
	}

	public getLibelleModePaiement(code: string): string {
    	switch (code) {
    		case "T":
    			return "Prélèvement SEPA";
    		case "V":
    			return "Virement";
    		case "C":
    			return "Patronal";
    	}

    	return "";
	}

	public getLibelleTypeDeBase(code: number): string {
    	switch (code) {
    		case 10:
    			return "Salaire brut prévoyance";
    		case 11:
    			return "TA prévoyance";
    		case 13:
    			return "TB prévoyance";
    		case 18:
    			return "Base forfaitaire";
    		case 20:
    			return "Montant forfaitaire";
		}

    	return "";
	}

	public getLibelleRubrique(code: string): string {
    	if (code != undefined) {
    		for (const r of this.rubriques) {
    			if (code == r.CodeRubrique) {
    				if (r.LibelleRubrique != undefined) {
						return r.LibelleRubrique;
					}
    			}
    		}
    	}

    	return "";
	}
}



// WEBPACK FOOTER //
// ./src/components/ficheSociete/dsn/dsnSociete.ts